<ng-container *ngFor="let followUp of followUps.controls; let i = index; trackBy: trackByIndex">
  <div class="bg-primary p-4 text-white rounded-t flex justify-between items-center">
    <h2 class="text-lg font-semibold">Job Follow Up:</h2>

    <!-- Delete Icon -->
    <div class="flex flex-col items-end justify-between ml-2">
      <button
        mat-icon-button
        class="!text-white"
        aria-label="Delete Follow Up"
        (click)="removeFollowUp.emit(i)"
        *ngIf="!viewDisable"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <div
    [formGroup]="asFormGroup(followUp)"
    class="bg-white p-6 rounded-b shadow flex flex-col md:flex-row gap-6 border-t border-gray-200 mb-4"
  >
    <!-- 1st Follow Up -->
    <div class="flex-1 flex flex-col gap-4">
      <div class="font-medium">{{ i + 1 | ordinal }} Follow Up</div>
      <mat-form-field
        appearance="fill"
        class="w-full"
        *ngIf="!viewDisable || asFormGroup(followUp).get('dateFollowUp')?.value"
      >
        <mat-label>Date of Follow Up</mat-label>
        <input
          matInput
          [matDatepicker]="firstFollowUpPicker"
          formControlName="dateFollowUp"
          placeholder="mm/dd/yyyy"
        />
        <mat-datepicker-toggle matSuffix [for]="firstFollowUpPicker"></mat-datepicker-toggle>
        <mat-datepicker #firstFollowUpPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="w-px bg-gray-200 hidden md:block"></div>

    <!-- Prior Dates Promised -->
    <div class="flex-1 flex flex-col gap-4">
      <div class="font-medium">Prior Dates Promised:</div>
      <mat-form-field
        appearance="fill"
        class="w-full"
        *ngIf="!viewDisable || asFormGroup(followUp).get('priorFirstDate')?.value"
      >
        <mat-label>1st Date</mat-label>
        <input
          matInput
          [matDatepicker]="prior1Picker"
          formControlName="priorFirstDate"
          placeholder="mm/dd/yyyy"
        />
        <mat-datepicker-toggle matSuffix [for]="prior1Picker"></mat-datepicker-toggle>
        <mat-datepicker #prior1Picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        appearance="fill"
        class="w-full"
        *ngIf="!viewDisable || asFormGroup(followUp).get('priorSecondDate')?.value"
      >
        <mat-label>2nd Date</mat-label>
        <input
          matInput
          [matDatepicker]="prior2Picker"
          formControlName="priorSecondDate"
          placeholder="mm/dd/yyyy"
        />
        <mat-datepicker-toggle matSuffix [for]="prior2Picker"></mat-datepicker-toggle>
        <mat-datepicker #prior2Picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        appearance="fill"
        class="w-full"
        *ngIf="!viewDisable || asFormGroup(followUp).get('priorThirdDate')?.value"
      >
        <mat-label>3rd Date</mat-label>
        <input
          matInput
          [matDatepicker]="prior3Picker"
          formControlName="priorThirdDate"
          placeholder="mm/dd/yyyy"
        />
        <mat-datepicker-toggle matSuffix [for]="prior3Picker"></mat-datepicker-toggle>
        <mat-datepicker #prior3Picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="w-px bg-gray-200 hidden md:block"></div>

    <!-- Notes and Material Supplier -->
    <div class="flex-1 flex flex-col gap-4">
      <div class="font-medium">Follow-Up Notes / Material Needed to Finish Job:</div>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Notes</mat-label>
        <textarea matInput rows="2" formControlName="notes"></textarea>
      </mat-form-field>
      <div class="flex items-center gap-4 mt-2">
        <span class="font-medium">Material Supplier:</span>
        <mat-checkbox formControlName="ciw">CIW</mat-checkbox>
        <mat-checkbox formControlName="cfm">CFM</mat-checkbox>
      </div>
    </div>
  </div>
</ng-container>
<div class="flex justify-end p-4 bg-white border-t border-gray-200 rounded-b">
  <button
    mat-flat-button
    color="primary"
    type="button"
    class="!bg-green-600 !text-white"
    (click)="addFollowUp.emit()"
    *ngIf="!viewDisable"
  >
    ADD FOLLOW-UP +
  </button>
</div>
